'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _LargeButton = require('./LargeButton');

var _LargeButton2 = _interopRequireDefault(_LargeButton);

var _Text = require('./Text');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Submit = (0, _styledComponents2.default)(_Button2.default.input).attrs({
  type: 'submit'
})([], _Text.caps);

Submit.lg = (0, _styledComponents2.default)(_LargeButton2.default.input).attrs({
  type: 'submit'
})([], _Text.caps);

var attrs = {
  theme: _theme2.default,
  caps: true
};

Submit.defaultProps = attrs;
Submit.lg.defaultProps = attrs;

exports.default = Submit;